import { CommonModule } from "@angular/common";
import { ModuleWithProviders, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { FooterComponent } from './components/footer/footer.component';
import { CustomFlagNamePipe, TranslationLabelPipe } from "./pipes/translation-label.pipe";
import { ApiService } from "./services/api-service";

@NgModule({
  declarations: [
    FooterComponent,
    TranslationLabelPipe,
    CustomFlagNamePipe,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
  ],
  exports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,

    FooterComponent,
    TranslationLabelPipe,
    CustomFlagNamePipe,
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [ApiService],
    };
  }
}
